enum RightLeftDirectionEnum {
	RIGHT = 'RIGHT',
	LEFT = 'LEFT',
}

export default RightLeftDirectionEnum;
